import accessControlProfiles from './access-control-profiles.json';

export default {
  accessControlProfiles,
};
